import React, { Component } from 'react';

import { Transition } from "react-transition-group";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

import './TimeNavbar.css';


const VALID_ELAPSED_TIME_FROM_LAST_ACTION_MSEC = 1000 * 60 * 2;


export function computeDuration(activities) {
  const segments = [];
  let currentSegment = [];
  let lastTime = null;
  const allActivities = activities || [];
  allActivities.sort((a, b) => {
    if (a.time < b.time) {
      return -1;
    }
    if (a.time > b.time) {
      return 1;
    }
    return 0;
  });
  allActivities.forEach((a) => {
    if (!a.time) {
      return;
    }
    if (!lastTime || a.time - lastTime > VALID_ELAPSED_TIME_FROM_LAST_ACTION_MSEC) {
      currentSegment = [];
      currentSegment.push(a);
      segments.push(currentSegment);
    } else {
      currentSegment.push(a);
    }
    lastTime = a.time;
  });
  return {
    duration: segments.map((a) => a[a.length - 1].time - a[0].time).reduce((x, y) => x + y, 0),
    last: currentSegment.length === 0 ? null : currentSegment[currentSegment.length - 1].time,
  };
}


export class TimeNavbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      started: true,
      expand: false,
      elapsed: '00:00',
      stopped: false,
    };
    this.timerId = null;
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    if (!this.timerId) {
      return;
    }
    clearInterval(this.timerId);
    this.timerId = null;
  }

  componentDidUpdate(prevProps) {
    this.updateTimer(prevProps);
  }

  startTimer() {
    if (!this.props.started) {
      return;
    }
    this.timerId = setInterval(() => this.processTimer(), 250);
  }

  updateTimer(prevProps) {
    if (this.timerId && prevProps && prevProps.started !== this.props.started) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    if (this.timerId) {
      return;
    }
    this.startTimer();
  }

  processTimer() {
    const now = Date.now();
    if (this.props.lastActionAt && this.props.lastActionAt + VALID_ELAPSED_TIME_FROM_LAST_ACTION_MSEC < now) {
      // 最終アクションから規定時間経ってしまった ... タイマーは更新しない
      this.setState({
        stopped: true,
      });
      return;
    }
    const elapsedMsec = now - this.props.started;
    this.setState({
      elapsed: this.getElapsedText(elapsedMsec + (this.props.baseDuration || 0)),
      started: this.state.started && elapsedMsec < 10 * 1000, // 10秒の間はインジケーターを出す
      stopped: false,
    });
  }

  getElapsedText(elapsedMsec) {
    const elapsedSec = parseInt(elapsedMsec / 1000);
    let secText = `${elapsedSec % 60}`;
    if (secText.length < 2) {
      secText = '0' + secText;
    }
    const elapsedMin = parseInt(elapsedSec / 60);
    let minText = `${elapsedMin % 60}`;
    if (minText.length < 2) {
      minText = '0' + minText;
    }
    return `${parseInt(elapsedMin / 60)}:${minText}:${secText}`;
  }

  getRightStyle(stateOpen, stateExpand) {
    let transition = null;
    if (stateOpen === 'entering' || stateOpen === 'exiting') {
      transition = 'all 1s ease';
    } else if (stateExpand === 'entering' || stateExpand === 'exiting') {
      transition = 'all 500ms ease';
    }
    let rightPx = 0;
    if (stateOpen.match(/^exit.+$/)) {
      rightPx = -192;
    } else if (stateExpand.match(/^exit.+$/)) {
      rightPx = -138;
    }
    const right = `${rightPx}px`;
    if (!transition) {
      return { right };
    }
    return { transition, right };
  }

  renderNavbar(stateOpen, stateExpand) {
    const time = (this.state.started || this.state.expand) ? this.state.elapsed : '_:__:__';
    return (<div className='TimeNavbarRoot' style={this.getRightStyle(stateOpen, stateExpand)}>
      <div>
        <div
          className={'TimeNavbar' + (this.state.stopped ? ' TimeNavbarStopped' : '')}
          onMouseEnter={() => this.setState({ expand: true })}
          onMouseLeave={() => this.setState({ expand: false })}
          onClick={()=> this.setState({ expand: !this.state.expand })}
        >
          <FontAwesomeIcon icon={faClock} />
          <span className='TimeIndicator'>
            学習時間
          </span>
          <span>{time}</span>
          {this.state.stopped && <div className='TimeNavbarStoppedMessage'>
              学習を再開すると<br />時間計測を再開します。
            </div>}
        </div>
      </div>
    </div>)
  }

  render() {
    return (<Transition in={this.props.open} timeout={1000} >
      {(stateOpen) => <Transition in={this.state.started || this.state.expand} timeout={1000} >
          {(stateExpand) => this.renderNavbar(stateOpen, stateExpand)}
        </Transition>}
    </Transition>)
  }
}
